"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-unknown-property */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../../../_util/useConfig"));
var ThemeContext = react_1.default.createContext({});
function animates(ball, targetX, targetY) {
    var easing = 0.2;
    // if (ball.x > 295) {
    //     debugger;
    // }
    ball.x += (targetX - ball.x) * easing;
    ball.y += (targetY - ball.y) * easing;
    return { x: ball.x, y: ball.y, targetX: targetX };
}
var children;
var tabKey = 0;
var TabPane = function (props) {
    var key = props.key, tabIndex = props.tabIndex, title = props.title, record = props.record, onTabClick = props.onTabClick;
    var value = (0, react_1.useContext)(ThemeContext);
    var compute = function () {
        var childrenParentNodes = value.inputEl.current;
        var childrenNodes = childrenParentNodes ? childrenParentNodes.childNodes || [] : [];
        // todo optimize
        for (var i = 0; i < childrenNodes.length - 1; i++) {
            if (i === 0) {
                if (childrenNodes[i].childNodes[0]) {
                    var childrenElementWidth = childrenNodes[i].clientWidth;
                    childrenNodes[childrenNodes.length - 1].style.width = "".concat(childrenElementWidth, "px");
                }
                childrenNodes[i].className = 'tce-tabs-tab tce-tabs-tab-active';
            }
        }
    };
    var tabBor = function () {
        var childrenParentNodes = value.inputEl.current;
        var childrenNodes;
        if (children && children.childNodes) {
            childrenNodes = children.childNodes;
        }
        else {
            childrenNodes = childrenParentNodes ? childrenParentNodes.childNodes || [] : [];
        }
        // todo optimize
        if (childrenNodes[tabKey]
            && childrenNodes[tabKey].childNodes
            && childrenNodes[tabKey].childNodes[0]) {
            var childrenElementWidth = childrenNodes[tabKey].clientWidth;
            var elementWidth = childrenNodes[tabKey] && childrenNodes[tabKey];
            var elementWidth_child_width = elementWidth ? elementWidth.offsetLeft : 0;
            childrenNodes[childrenNodes.length - 1].style.left = "".concat(elementWidth_child_width, "px");
            childrenNodes[childrenNodes.length - 1].style.width = "".concat(childrenElementWidth, "px");
        }
    };
    (0, react_1.useEffect)(function () {
        compute();
        window.addEventListener('resize', tabBor);
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: (0, classnames_1.default)('tce-tabs-tab', {
            // 'tce-tabs-tab-active': classStatus
            }), "report-event": "click_tab_button", "report-ext1": tabIndex, "report-ext2": title || '', onClick: function (event) {
                onTabClick && onTabClick(record, tabIndex, event);
                if (value.onCallback) {
                    value.onCallback(props);
                }
                var childrenParentNodes = value.inputEl.current;
                children = childrenParentNodes;
                var controlTabs = value.inputElCont.current;
                // const controlTabs = document.getElementById('tce-tabs-content-holder') || {} as any;
                var childrenNodes = childrenParentNodes ? childrenParentNodes.childNodes || [] : [];
                var childrenNodesControlTabs = controlTabs ? controlTabs.childNodes || [] : [];
                // todo optimize
                for (var i = 0; i < childrenNodes.length - 1; i++) {
                    if (i === tabIndex - 1) {
                        tabKey = i;
                        var elementWidth = childrenNodes[i] && childrenNodes[i];
                        var elementWidth_child_width = elementWidth ? elementWidth.offsetLeft : 0;
                        childrenNodes[childrenNodes.length - 1].style.left = "".concat(elementWidth_child_width, "px");
                        if (childrenNodes
                            && childrenNodes[i]
                            && childrenNodes[i].childNodes
                            && childrenNodes[i].childNodes[0]) {
                            var childrenElementWidth = childrenNodes[i].clientWidth;
                            childrenNodes[childrenNodes.length - 1].style.width = "".concat(childrenElementWidth + 12, "px");
                        }
                        if (childrenNodesControlTabs[i] && childrenNodesControlTabs[i].style) {
                            childrenNodesControlTabs[i].style.display = 'block';
                        }
                        childrenNodes[i].className = 'tce-tabs-tab tce-tabs-tab-active';
                    }
                    else {
                        if (childrenNodesControlTabs[i] && childrenNodesControlTabs[i].style) {
                            childrenNodesControlTabs[i].style.display = 'none';
                        }
                        childrenNodes[i].className = 'tce-tabs-tab ';
                    }
                }
            }, key: key },
            react_1.default.createElement("div", { role: "tab", "aria-selected": "true", className: 'tce-tabs-tab-btn', id: "rc-tabs-0-tab-1", "aria-controls": "rc-tabs-0-panel-1" }, title))));
};
var Tabs = function (props) {
    var children = props.children, onClick = props.onClick, onCallback = props.onCallback, onTabClick = props.onTabClick, record = props.record, restProps = __rest(props, ["children", "onClick", "onCallback", "onTabClick", "record"]);
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var collectChildren = [];
    react_1.Children.forEach(children, function (item) {
        var _ = item ? item.props : null;
        collectChildren.push(_.children);
    });
    var inputEl = (0, react_1.useRef)(null);
    var inputElCont = (0, react_1.useRef)(null);
    var innerRef = (0, react_1.useRef)(null);
    var leftRef = (0, react_1.useRef)(null);
    var rightRef = (0, react_1.useRef)(null);
    var val = { x: 0 };
    var scale = 0.1;
    var valDirectionRight = true;
    var runRequestFunc = function (getInnerChild_1, deadline, currentScroll) {
        requestAnimationFrame(function () {
            if (!rightRef.current || !leftRef.current)
                return;
            val = animates({ x: currentScroll || getInnerChild_1.scrollLeft }, deadline);
            if (val.x > getInnerChild_1.scrollWidth - getInnerChild_1.clientWidth) {
                rightRef.current.style.display = 'none';
            }
            else {
                rightRef.current.style.display = 'block';
            }
            if (val.x < 10) {
                leftRef.current.style.display = 'none';
            }
            else {
                leftRef.current.style.display = 'block';
            }
            getInnerChild_1.scrollLeft = val.x;
            if (valDirectionRight && deadline - val.x > scale) {
                runRequestFunc(getInnerChild_1, deadline, Math.fround(val.x));
            }
            else if (!valDirectionRight && deadline - val.x < -scale) {
                runRequestFunc(getInnerChild_1, deadline, Math.fround(val.x));
            }
            displayRight();
        });
    };
    var _requestAnimationFrame = function (getInnerChild_1, deadline) {
        valDirectionRight = deadline > getInnerChild_1.scrollLeft;
        runRequestFunc(getInnerChild_1, deadline);
    };
    var moveToNode = function () {
        var getInnerChild = innerRef.current;
        var getInnerChild_1 = getInnerChild && getInnerChild.childNodes && getInnerChild.childNodes[0];
        return getInnerChild_1;
    };
    var moveToFunc = function (deadline) {
        _requestAnimationFrame(moveToNode(), deadline);
    };
    var displayRight = function () {
        if (!rightRef.current)
            return;
        if (moveToNode().scrollWidth <= 1392) {
            rightRef.current.style.display = 'none';
        }
    };
    (0, react_1.useEffect)(function () {
        if (val.x < 10 && leftRef && leftRef.current && leftRef.current.style) {
            leftRef.current.style.display = 'none';
        }
        displayRight();
    }, []);
    return (react_1.default.createElement("div", __assign({ className: "".concat(classPrefix, "__tceTab") }, restProps),
        react_1.default.createElement(ThemeContext.Provider, { value: {
                inputEl: inputEl,
                inputElCont: inputElCont,
                collectChildren: collectChildren,
                onCallback: onCallback,
            } },
            react_1.default.createElement("div", { className: "".concat(classPrefix, "__tceTab-tabs") },
                collectChildren && collectChildren.length > 1 ? (react_1.default.createElement("div", { className: "".concat(classPrefix, "__tceTab-tabs-list"), ref: innerRef },
                    react_1.default.createElement("div", { ref: inputEl, className: "".concat(classPrefix, "__tceTab-tabs-list-copy") },
                        react_1.Children.map(children, function (item) { return item; }),
                        react_1.default.createElement("div", { style: { left: 0, width: '36px' } })))) : (react_1.default.createElement("div", { className: "".concat(classPrefix, "__tceTab-tabs-list"), ref: innerRef, style: { display: 'none' } },
                    react_1.default.createElement("div", { ref: inputEl, className: "".concat(classPrefix, "__tceTab-tabs-list-copy") }))),
                react_1.default.createElement("div", { ref: inputElCont, className: "".concat(classPrefix, "__tceTab-tabs-content-holder") }, react_1.Children.map(collectChildren, function (item) { return item; }))))));
};
Tabs.TabPane = TabPane;
exports.default = Tabs;
//# sourceMappingURL=index.js.map